import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, take } from 'rxjs';
import { IDictionaryProviderService, IDictionaryValue } from '@common/dictionaries';
import { ProjectBasicDataDictionary } from '../basic-data.constants';
import { BackendApiProjectsSectorsService } from '@app/backend/metadoor-api-client';

const namespace = 'project-basic-data:';

@Injectable()
export class ProjectBasicDataDictionariesService implements IDictionaryProviderService {
  constructor(private backend: BackendApiProjectsSectorsService) {}

  getDictionaryValuesByType(typeCode: string): Observable<IDictionaryValue[]> {
    const storeKey = namespace + typeCode;
    if (!ProjectBasicDataDictionary.store.has(storeKey)) {
      return this.backend.projectsProjectsEnumsRetrieve().pipe(
        map((enums: any) => {
          Object.keys(enums).forEach((key) => {
            const values = enums[key].map((item: any) => ({
              typeCode: key,
              code: item.id,
              name: item.name,
            }));
            const saveKey = namespace + key;
            ProjectBasicDataDictionary.store.set(saveKey, values);
          });
          return ProjectBasicDataDictionary.store.get(storeKey) || [];
        }),
        catchError((err) => {
          return of([]);
        }),
      );
    }
    return of(
      ProjectBasicDataDictionary.store.get(storeKey) || [{ code: 'none', name: 'отсуствует', typeCode: 'none' }],
    );
  }

  /** метод для инициализации всех справочников */
  init() {
    // this.getDictionaryValuesByType('').pipe(take(1)).subscribe();
  }
}
